import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { publicAdviserApi, type PublicAdviser } from './api';
import { AdviserCard } from './AdviserProfileView';

export default function FeaturedAdvisers() {
  const [advisers, setAdvisers] = useState<PublicAdviser[]>([]);
  useEffect(() => {
    let active = true;
    publicAdviserApi
      .list({ featured: true, limit: 3 })
      .then((data) => {
        if (active) setAdvisers(data.advisers || []);
      })
      .catch(() => {
        /* The homepage remains usable if discovery is unavailable. */
      });
    return () => {
      active = false;
    };
  }, []);
  if (!advisers.length) return null;
  return (
    <section className="adviser-featured home-container" aria-labelledby="featured-advisers-title">
      <div className="adviser-section-heading">
        <div>
          <p className="adviser-eyebrow">Guidance for your next move</p>
          <h2 id="featured-advisers-title">Meet the people behind the plan.</h2>
          <p>Work with an adviser who understands your business.</p>
        </div>
        <Link to="/advisers" className="adviser-text-link">
          Explore all advisers <ArrowRight size={17} />
        </Link>
      </div>
      <div className="adviser-card-grid">
        {advisers.map((adviser) => (
          <AdviserCard key={adviser.slug} adviser={adviser} />
        ))}
      </div>
    </section>
  );
}
